
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-72327128\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./joursFeries.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./joursFeries.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-72327128\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./joursFeries.vue.html"),
  /* scopeId */
  "data-v-72327128",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/joursFeries/joursFeries.vue.html
// module id = 5mQM
// module chunks = 2